import { getAccountActivityRuleErrors, validateField as validateJsonField } from '../../../../components/InputField/helper';

const BUSINESS_PLUS_ACCOUNT_ACTIVITY_OPTIONS = {
    depositLocationFields: ["Deposit_Locations"],
    paymentLocationFields: ["Payment_Locations"],
};

export const validateBusinessPlusField = ({
    field,
    value,
    data,
    fieldMap,
}) => {
    const fieldConfig = fieldMap?.[field];
    if (!fieldConfig) {
        return null;
    }

    const fieldError = validateJsonField(fieldConfig, value, data);
    if (fieldError) {
        return fieldError;
    }

    if (!data?.interestedInPrime) {
        const activityError = getAccountActivityRuleErrors(data, BUSINESS_PLUS_ACCOUNT_ACTIVITY_OPTIONS)
            .find((err) => err.field === field)?.message;
        if (activityError) {
            return activityError;
        }
    }

    return null;
};
